
import React from 'react';
import PropTypes from 'prop-types';

import CarportImg1 from '../InstallImages/Carport/CarportImg1';
import CarportImg2 from '../InstallImages/Carport/CarportImg2';

import '../saleslogic.css';
import '../../../../../../grid.css';

const Carport = (props) => {
    const { firstName } = props;

    // images are 952 x 406

    return (
        <div className="row" >
            <h1 className="arrayType">Parking Canopy</h1>
            <div className="row installTextGroup">
                <p className="col span-1-of-3 installText">{firstName}, Carport Canopies are excellent structures on which Solvana installs PV solar-generating systems. Carport Canopies not only offer vast amounts of space to install PV solar-generating systems, but they also give you the bonus of having covered parking. PV solar Carport Canopies are also eligible for the same financial and tax benefits as other PV solar equipment and components. Solvana can even install Electric Vehicle (EV) Charging Stations, and optional low-voltage LED lighting, which can have added incentives of their own. </p>
                <p className="col span-2-of-3 installPics installPixRight">
                    <CarportImg1 />
                </p>
            </div>
            <div className="row installTextGroup">
                <p className="col span-2-of-3 installPics">
                    <CarportImg2 />
                </p>
                <p className="col span-1-of-3 installText">
                    {firstName}, after analyzing your electrical consumption and site conditions at your location, we conclude that installing your PV solar-generating system on a Carport Canopy maximizes its value. We base our decision on decades of experience and careful consideration of many factors, including roof area, roof obstructions, shading, electrical consumption, and available ground space. We have determined that this is the ideal place to maximize your financial benefits and ensure that your Solvana PV solar-generating system meets or exceeds your expectations. Solvana&apos;s Carport Canopies are custom designed to fit the needs of your electrical consumption. They are the perfect solution to extensive electrical usage, especially when roof space is too small to support enough PV solar equipment to produce enough energy to offset all of the electrical consumption. Solvana’s team of experts take great pride in our work, and you can trust we have your best interest at heart in every decision we make from design & engineering through construction.
                </p>

            </div>
        </div>
    );
};

Carport.propTypes = {
    firstName: PropTypes.string.isRequired,
};

export default Carport;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/Carport/Carport.js